module.exports = __webpack_public_path__ + "img/icon-alert-blue.93c2d5a7.svg";